export default __webpack_public_path__ + "locales/sr-Cyrl-RS/FillPDFDialog.json?hash=c58d8a9fad378f480239a68531ffa901";